module.exports = __webpack_public_path__ + "static/img/logo_000.8d2da40e.png";